import React from "react";
import { useRouter } from "next/router";
import pendingImage from "../../../../public/images/pending-approval.png";
import { useTranslation } from "react-i18next";
import ButtonOutlined from "../../../common/components/Buttons/ButtonOutlined";
import Button from "../../../common/components/Buttons/Button";
import { routes } from "../../../routes";
import ConfirmScreen from "../../../common/components/ConfirmScreen/ConfirmScreen";

const PendingApproval = () => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <ConfirmScreen
      imageSrc={pendingImage}
      title={t("pending-approval")}
      description={t("pending-approval-desc")}
      actions={
        <>
          <ButtonOutlined text={t("go-back")} onClick={() => router.back()} />
          <Button
            text={t("take-to-marketplace")}
            href={routes.marketplace.root}
          />
        </>
      }
    />
  );
};

export default PendingApproval;
